var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39.0006,
    height: 39.0006,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2449 28.2836L27.9999 16.0002H11.9995L13.7545 28.2836C13.8226 28.7602 14.0604 29.1962 14.4241 29.5116C14.7878 29.827 15.2531 30.0006 15.7346 30.0006H24.2648C24.7463 30.0006 25.2116 29.827 25.5753 29.5116C25.939 29.1962 26.1768 28.7602 26.2449 28.2836ZM10.9994 12.0001H15.9996V11C15.9996 10.7348 16.1049 10.4804 16.2925 10.2929C16.48 10.1054 16.7344 10 16.9996 10H22.9998C23.265 10 23.5194 10.1054 23.7069 10.2929C23.8945 10.4804 23.9998 10.7348 23.9998 11V12.0001H29C29.2652 12.0001 29.5196 12.1054 29.7071 12.293C29.8946 12.4805 30 12.7349 30 13.0001C30 13.2653 29.8946 13.5197 29.7071 13.7072C29.5196 13.8948 29.2652 14.0001 29 14.0001H10.9994C10.7342 14.0001 10.4798 13.8948 10.2923 13.7072C10.1047 13.5197 9.99939 13.2653 9.99939 13.0001C9.99939 12.7349 10.1047 12.4805 10.2923 12.293C10.4798 12.1054 10.7342 12.0001 10.9994 12.0001Z",
    fill: "#00406A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39.0006,
    height: 39.0006,
    rx: 5.5,
    stroke: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIc);
export default __webpack_public_path__ + "static/media/deleteIC.144af576cf481f79598984c011fcf3dd.svg";
export { ForwardRef as ReactComponent };